import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-business-report',
  templateUrl: './business-report.component.html',
  styleUrls: ['./business-report.component.scss']
})
export class BusinessReportComponent implements OnInit {

  reportData: any[] = [];
  grandTotals: any = {};
  months: string[] = [];

  startDate: any;
  endDate: any;
  today: Date = new Date();

  storageKey = 'business_report_uddisht';

  constructor(
    private service: DigisubservicesService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.startDate = this.data?.startDate;
    this.endDate = this.data?.endDate;

    this.getBusinessReport();
  }

  /* ================= API ================= */
  getBusinessReport() {

    const payload = {
      start_date: this.startDate,
      end_date: this.endDate,
      office_rep_name: this.data?.office_rep_name || []
    };

    this.service.getBusinessReport2(payload).subscribe((res: any) => {

      if (!res || res.status !== 'success') return;

      this.months = res.months || [];
      let data = res.data || [];

      // remove grand total row
      if (data.length && data[data.length - 1]?.office_rep_name === 'Grand Total') {
        data.pop();
      }

      this.reportData = data.map((g: any) => {

        const clean: any = {
          office_rep_name: g.office_rep_name,
          uddisht: Number(g.uddisht || 0),
          total_billing: Number(g.total_billing || 0),
          total_received: Number(g.total_received || 0)
        };

        this.months.forEach(m => {
          clean[m + '_billing'] = Number(g[m + '_billing'] || 0);
          clean[m + '_received'] = Number(g[m + '_received'] || 0);
        });

        return clean;
      });

      // load saved values
      this.loadFromLocal();

      // calculate totals
      this.calculateGrandTotals();
    });
  }

  /* ================= CHANGE HANDLER ================= */
  onUddishtChange(group: any) {
    group.uddisht = Number(group.uddisht || 0);

    this.saveToLocal();
    this.calculateGrandTotals();
  }

  /* ================= SAVE ================= */
  saveToLocal() {
    const data = this.reportData.map(g => ({
      office_rep_name: g.office_rep_name,
      uddisht: g.uddisht
    }));

    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  /* ================= LOAD ================= */
  loadFromLocal() {

    const saved = localStorage.getItem(this.storageKey);
    if (!saved) return;

    try {
      const parsed = JSON.parse(saved);

      this.reportData.forEach(group => {
        const match = parsed.find((x: any) =>
          x.office_rep_name === group.office_rep_name
        );

        if (match) {
          group.uddisht = Number(match.uddisht || 0);
        }
      });

    } catch (e) {
      console.error('LocalStorage Parse Error:', e);
    }
  }
   exportExcel(fileName: string): void {
    const element = document.getElementById('print-section');
    if (!element) return;

    try {
      const liveInputs = Array.from(element.querySelectorAll('input'));
      const liveValues = liveInputs.map((inp: any) => inp.value || '');

      const cloned = element.cloneNode(true) as HTMLElement;
      cloned.querySelectorAll('button, .button-container').forEach(el => el.remove());

      const clonedInputs = Array.from(cloned.querySelectorAll('input'));
      clonedInputs.forEach((input, index) => {
        const span = document.createElement('span');
        span.textContent = liveValues[index] ?? '';
        input.replaceWith(span);
      });

      const tables  = cloned.querySelectorAll('table');
      const dataTable = tables[tables.length - 1] as HTMLElement;
      if (!dataTable) return;

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(dataTable);

      // Auto column widths
      const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
      const colWidths: { wch: number }[] = [];
      for (let C = range.s.c; C <= range.e.c; C++) {
        let maxLen = 10;
        for (let R = range.s.r; R <= range.e.r; R++) {
          const cell = ws[XLSX.utils.encode_cell({ r: R, c: C })];
          if (cell?.v) maxLen = Math.max(maxLen, String(cell.v).length);
        }
        colWidths.push({ wch: maxLen + 2 });
      }
      ws['!cols'] = colWidths;

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, fileName + '.xlsx');

    } catch (error) {
      console.error('Export error:', error);
    }
  }

 printReportA3() {
  const printContent = document.getElementById('print-section');
  if (!printContent) return;

  // Clone content so we can safely remove buttons
  const clonedContent = printContent.cloneNode(true) as HTMLElement;

  // ================= REMOVE BUTTONS ONLY =================
  const buttons = clonedContent.querySelectorAll('.button-container, button, mat-button, mat-raised-button');
  buttons.forEach(btn => btn.remove());

  // ================= FIX INPUT VALUES FOR PRINT =================
  const inputs = clonedContent.querySelectorAll('input');

  inputs.forEach((input: any) => {
    const value = input.value || '';

    const span = document.createElement('span');
    span.textContent = value;

    // keep alignment same
    span.style.display = 'inline-block';
    span.style.width = input.style.width || '60px';
    span.style.textAlign = input.style.textAlign || 'right';

    input.replaceWith(span);
  });

  const WindowPrt = window.open('', '', 'width=1400,height=900');

  if (WindowPrt) {
    WindowPrt.document.open();

    WindowPrt.document.write(`
      <html>
        <head>
          <title>Business Report</title>

          <style>
            @page { size: A3 landscape; margin: 5mm; }

            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 0;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: auto;
            }

            th, td {
              border: 1px solid black;
              padding: 6px;
              font-size: 15px;
            }

            thead { display: table-header-group; }
            tfoot { display: table-footer-group; }

            tr { page-break-inside: avoid; }

            div { overflow: visible !important; }

            /* ================= FORCE COLORS ================= */

            thead tr {
              background-color: #f1f1f1 !important;
            }

            tr[style*="b0c4cf"] {
              background-color: #b0c4cf !important;
              font-weight: bold;
            }

            tr[style*="f4b084"] {
              background-color: #f4b084 !important;
              font-weight: bold;
            }

            tfoot tr {
              background-color: #c8753f !important;
              font-weight: bold;
              color: black;
            }

          </style>
        </head>

        <body>
          ${clonedContent.innerHTML}
        </body>
      </html>
    `);

    WindowPrt.document.close();

    setTimeout(() => {
      WindowPrt.focus();
      WindowPrt.print();
      WindowPrt.close();
    }, 500);
  }
}

  /* ================= TOTAL ================= */
  calculateGrandTotals() {

    const grand: any = {
      uddisht: 0,
      total_billing: 0,
      total_received: 0
    };

    this.months.forEach(m => {
      grand[m + '_billing'] = 0;
      grand[m + '_received'] = 0;
    });

    this.reportData.forEach(g => {

      grand.uddisht += Number(g.uddisht || 0);
      grand.total_billing += Number(g.total_billing || 0);
      grand.total_received += Number(g.total_received || 0);

      this.months.forEach(m => {
        grand[m + '_billing'] += Number(g[m + '_billing'] || 0);
        grand[m + '_received'] += Number(g[m + '_received'] || 0);
      });

    });

    this.grandTotals = grand;
  }

  /* ================= FARAK ================= */
getFarak(group: any): number {
  const uddisht = Number(group.uddisht || 0);
  const billing = Number(group.total_billing || 0);

  if (!uddisht) return 0;

  return uddisht - billing;   // IMPORTANT: reversed logic as per your need
}

getGrandFarak(): number {
  return this.reportData.reduce((sum, row) => {
    return sum + this.getFarak(row);
  }, 0);
}

}